export enum SideMenuReportEnum {
    Drivers = 1,
    Customers = 2,
    Revenue = 3,
    Disbursements = 4
}
